export default __webpack_public_path__ + "static/media/enabillgroupBill.e88130e5.svg";